/**
 * Pure helper: validates a list of files against a single byte budget.
 *
 * Rules:
 *  1. No individual file may exceed the budget.
 *  2. The cumulative size of all files may not exceed the budget.
 *
 * The first failing rule wins. Per-file beats total so the user sees
 * the specific offending filename when one file is the obvious cause.
 *
 * The helper is intentionally i18n-free so it can be unit-tested
 * without React or react-i18next. Callers translate the result.
 */
export type FileSizeCheck =
  | { kind: 'ok' }
  | { kind: 'single'; file: File; sizeBytes: number }
  | { kind: 'total'; sizeBytes: number };

export const checkFileSizes = (files: File[], maxBytes: number): FileSizeCheck => {
  for (const file of files) {
    if (file.size > maxBytes) {
      return { kind: 'single', file, sizeBytes: file.size };
    }
  }

  let total = 0;
  for (const file of files) total += file.size;
  if (total > maxBytes) {
    return { kind: 'total', sizeBytes: total };
  }

  return { kind: 'ok' };
};
